import axios from "axios";
import { baseURL } from "../../../base-url.js";

export default {
  async getAllSalons({ commit }) {
    const token = localStorage.getItem("jwt");

    try {
      const response = await axios.get(`${baseURL}/salon/getAllSalons`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      commit("setSalons", response.data);
      return response.data;
    } catch (error) {
      throw error.response || error;
    }
  },

  async getSalonDetails({ commit }, salonId) {
    const token = localStorage.getItem("jwt");

    try {
      const response = await axios.get(`${baseURL}/salon/getSalonDetails`, {
        params: { id: salonId },
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      commit("setSalonDetails", response.data);
      return response.data;
    } catch (error) {
      const message = error.response?.data || "Nieznany błąd";
      console.error(`Błąd pobierania szczegółów salonu: ${message}`);
      throw error.response;
    }
  },

  async createSalon(_, payload) {
    const token = localStorage.getItem("jwt");

    try {
      await axios.post(`${baseURL}/salon/createSalon`, payload, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
    } catch (error) {
      throw error.response;
    }
  },

  async updateSalon(_, payload) {
    const token = localStorage.getItem("jwt");
    try {
      const response = await axios.put(`${baseURL}/salon/updateSalon`, payload, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      return response;
    } catch (error) {
      throw error.response;
    }
  },

  async fetchVoucherStock({ commit }, salonId) {
    try {
      const response = await axios.get(`${baseURL}/voucher/stock`, {
        params: { salonId },
        headers: { Authorization: `Bearer ${localStorage.getItem('jwt')}` }
      });
      commit('setVoucherStock', response.data);
      return response.data;
    } catch (error) {
      commit('clearVoucherStock', salonId);
      throw error.response || error;
    }
  },

  async setVoucherStock({ commit }, { salonId, quantity }) {
    try {
      const response = await axios.put(`${baseURL}/voucher/stock`, { salonId, quantity }, {
        headers: { Authorization: `Bearer ${localStorage.getItem('jwt')}` }
      });
      commit('setVoucherStock', response.data);
      return response.data;
    } catch (error) {
      throw error.response || error;
    }
  },

  async fetchVoucherStockHistory(_, { salonId, page = 0, size = 20, startDate, endDate }) {
    try {
      const response = await axios.get(`${baseURL}/voucher/stock/history`, {
        params: { salonId, page, size, startDate: startDate || undefined, endDate: endDate || undefined },
        headers: { Authorization: `Bearer ${localStorage.getItem('jwt')}` }
      });
      return response.data;
    } catch (error) {
      throw error.response || error;
    }
  }

}
